import Slider from '@material-ui/core/Slider';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import './CategoryPriceSlider.style';

/** @namespace AdvoxBasic/Component/CategoryPriceSlider/Component/CategoryPriceSlider */
export class CategoryPriceSlider extends PureComponent {
    static propTypes = {
        minAvailable: PropTypes.number.isRequired,
        maxAvailable: PropTypes.number.isRequired,
        valuesRange: PropTypes.instanceOf(Array).isRequired,
        handleChangeSlider: PropTypes.func.isRequired,
        handleChangeInputMin: PropTypes.func.isRequired,
        handleChangeInputMax: PropTypes.func.isRequired,
        handleButtonClick: PropTypes.func.isRequired,
    };

    render() {
        const {
            minAvailable,
            maxAvailable,
            valuesRange,
            handleChangeSlider,
            handleChangeInputMin,
            handleChangeInputMax,
            handleButtonClick,
        } = this.props;

        return (
            <div block="CategoryPriceSlider">
                <Slider
                    min={minAvailable}
                    max={maxAvailable}
                    value={valuesRange}
                    onChange={handleChangeSlider}
                    className="CategoryPriceSlider-Slider"
                />

                <div block="CategoryPriceSlider" elem="InputsWrapper">
                    <input
                        block="CategoryPriceSlider"
                        elem="Input"
                        type="number"
                        value={valuesRange[0]}
                        onChange={handleChangeInputMin}
                    />

                    <input
                        block="CategoryPriceSlider"
                        elem="Input"
                        type="number"
                        value={valuesRange[1]}
                        onChange={handleChangeInputMax}
                    />
                </div>

                <button
                    block="Button"
                    mods={{ small: true }}
                    mix={{ block: 'CategoryPriceSlider', elem: 'Button' }}
                    onClick={handleButtonClick}
                >
                    {__('Apply')}
                </button>
            </div>
        );
    }
}

export default CategoryPriceSlider;
